import React from 'react'
import { Card, CardContent, CardHeader, Container, Header, Grid} from 'semantic-ui-react'

const About = () => (
  <Grid centered columns={3}>
  <Grid.Column>
    <Card
      header='Puzzel Administration'
      description='Detta är en react webb applikation för administration av A3 Växel.'
    >
    </Card>
    </Grid.Column>
  </Grid>
)

export default About;